import * as React from 'react';
import { Post } from '../../types';
// @ts-ignore
import Dummy from 'dummyjs'


export default function PostPartsDummy(props: {
  post: Post
  style?: {}
}) {

  const height = (Math.floor(Math.random() * 7) + 1) * 100

  return (
    <React.Fragment>
      <div><img src={Dummy.src(500, height)} style={{ width: '100%' }} /></div>
      <div>{Dummy.text('20,60')}</div>
    </React.Fragment >
  );
}